import { gql } from 'graphql-request'

export const deleteSickTracking = gql`
  mutation DeleteSickTracking(
    $id: ID!) {
    deleteSickTracking(id: $id)
  }
`

export const createOfftimeDay = gql`
  mutation CreateOfftimeDay(
    $date: Date!
    $name: String!
    $length: Float!
    $is_holiday: Boolean!
  ) {
    createOfftimeDay(
      date: $date
      name: $name
      length: $length
      is_holiday: $is_holiday
    ) {
      id
      date
      name
      length
      is_holiday
    }
  }
`

export const updateOfftimeDay = gql`
  mutation UpdateOfftimeDay(
    $id: ID!
    $date: Date
    $name: String
    $length: Float
    $is_holiday: Boolean
  ) {
    updateOfftimeDay(
      id: $id
      date: $date
      name: $name
      length: $length
      is_holiday: $is_holiday
    ) {
      id
      date
      name
      length
      is_holiday
    }
  }
`

export const deleteOfftimeDay = gql`
  mutation DeleteOfftimeDay($id: ID!) {
    deleteOfftimeDay(id: $id)
  }
`

export const createCar = gql`
  mutation CreateCar(
    $plate: String!
    $driveway: Int
    $driveway_enttro: Int
    $user_id: ID!
  ) {
    createCar(
      plate: $plate
      driveway: $driveway
      driveway_enttro: $driveway_enttro
      user_id: $user_id
    ) {
      id
      plate
      driveway
      driveway_enttro
      user {
        id
        username
      }
    }
  }
`

export const deleteCar = gql`
  mutation DeleteCar($id: ID!) {
    deleteCar(id: $id)
  }
`

export const updateCar = gql`
  mutation UpdateCar(
    $id: ID!
    $plate: String
    $driveway: Int
    $driveway_enttro: Int
    $user_id: ID
  ) {
    updateCar(
      id: $id
      plate: $plate
      driveway: $driveway
      driveway_enttro: $driveway_enttro
      user_id: $user_id
    ) {
      id
      plate
      driveway
      driveway_enttro
      user {
        id
        username
      }
    }
  }
`

export const updateUser = gql`
  mutation UpdateUser(
    $id: ID!
    $full_name: String
    $email: String
    $user_type: Int
    $active: Boolean
    $holiday_total: Int
    $holiday_rest: Int
    $time_credit: Float!
    $exit_date: Date
    $job_title: String
    $status: String
    $daily_work_time: Float
    $work_schedule: UserWorkScheduleInput
    $hourly_wage: Float!
    $fixed_hour_deduction: Float!
    $expenses: Boolean!
    $internal_number: Int!
    $datev_enabled: Boolean!
    $emergency_service_enabled: Boolean!
    $has_fixed_salary: Boolean!
  ) {
    updateUser(
      id: $id
      full_name: $full_name
      email: $email
      user_type: $user_type
      active: $active
      holiday_total: $holiday_total
      holiday_rest: $holiday_rest
      time_credit: $time_credit
      exit_date: $exit_date
      job_title: $job_title
      status: $status
      daily_work_time: $daily_work_time
      work_schedule: $work_schedule
      hourly_wage: $hourly_wage
      fixed_hour_deduction: $fixed_hour_deduction
      expenses: $expenses
      internal_number: $internal_number
      datev_enabled: $datev_enabled
      emergency_service_enabled: $emergency_service_enabled
      has_fixed_salary: $has_fixed_salary
    ) {
      id
      full_name
      email
    }
  }
`

export const createUser = gql`
  mutation CreateUser(
    $first_name: String!,
    $last_name: String!,
    $email: String!,
    $user_type: Int!,
    $holidays: Int!,
    $hourly_wage: Float!,
    $entry_date: Date!,
    $job_title: String!,
    $status: String!,
    $has_car: Boolean!,
    $expenses: Boolean!,
    $internal_number: Int!,
    $fixed_hour_deduction: Float!,
    $daily_work_time: Float!,
    $work_schedule: UserWorkScheduleInput,
    $datev_enabled: Boolean!
    $emergency_service_enabled: Boolean!
    $has_fixed_salary: Boolean!
  ) {
    createUser(
      first_name: $first_name,
      last_name: $last_name,
      email: $email,
      user_type: $user_type,
      holidays: $holidays,
      hourly_wage: $hourly_wage,
      entry_date: $entry_date,
      job_title: $job_title,
      status: $status,
      has_car: $has_car,
      expenses: $expenses,
      internal_number: $internal_number,
      fixed_hour_deduction: $fixed_hour_deduction,
      daily_work_time: $daily_work_time,
      work_schedule: $work_schedule
      datev_enabled: $datev_enabled
      emergency_service_enabled: $emergency_service_enabled
      has_fixed_salary: $has_fixed_salary
    ) {
      id
      username
      email
      token
      active
    }
  }
`

export const deleteUser = gql`
  mutation DeleteUser($id: ID!) {
    deleteUser(id: $id)
  }
`

export const deleteTracking = gql`
  mutation DeleteTracking(
    $id: ID!, 
    $type: TrackingType!,
    $reason: String) 
  {
    deleteTracking(
      id: $id, 
      type: $type
      reason: $reason)
  }
`

export const getUserTrackings = gql`
  query GetUserTrackings(
    $user_id: ID!, 
    $month: Int, 
    $year: Int) {
      getUserTrackings(
      user_id: $user_id, 
      month: $month, 
      year: $year) {
        id
        type
        client
        date
        duration
        comment
        locked
        isEmergency
      }
  }
`

export const closeMonthAdmin = gql`
  mutation CloseMonthAdmin(
    $userId: ID!
    $month: Int!
    $year: Int!
    $comment: String
    $payed_overtime_hours: Float!
    $adjust_overtime: Float 
  ) {
    closeMonthAdmin(
      userId: $userId
      month: $month
      year: $year
      comment: $comment
      payed_overtime_hours: $payed_overtime_hours
      adjust_overtime: $adjust_overtime
    ) {
      id
    }
}
`

export const updateTimetracking = gql`
  mutation UpdateTimetracking(
    $id: Int!
    $client: String
    $duration: Float
    $comment: String
    $is_night_work: Boolean
    $is_emergency_service: Boolean
  ) {
    updateTimetracking(
      id: $id
      client: $client
      duration: $duration
      comment: $comment
      is_night_work: $is_night_work
      is_emergency_service: $is_emergency_service
    ) {
      id
      client
      duration
      comment
      is_night_work
      is_emergency_service
    }
  }
`

export const fetchDataFromDatev = gql`
  mutation fetchDataFromDatev(
    $month: Int! ,
    $year: Int!) {
      fetchDataFromDatev(
      month: $month,
      year: $year)
  }
`
export const createDocument = gql`
  mutation CreateDocument(
    $user_id: ID!
    $document_category_id: ID!
    $file: Upload!
    $valid_from: Date
    $valid_until: Date
  ) {
    createDocument(
      user_id: $user_id
      document_category_id: $document_category_id
      file: $file
      valid_from: $valid_from
      valid_until: $valid_until
    ) {
      id
      documentCategory { id name }
      valid_from
      valid_until
      file_path
      created_at
    }
  }
`;
 
export const updateDocument = gql`
  mutation UpdateDocument(
    $id: ID!
    $file: Upload
    $valid_from: Date
    $valid_until: Date
  ) {
    updateDocument(
      id: $id
      file: $file
      valid_from: $valid_from
      valid_until: $valid_until
    ) {
      id
      documentCategory { id name }
      valid_from
      valid_until
      file_path
      created_at
    }
  }
`;
 
export const sendNewUserMail = gql`
  mutation SendNewUserMail($user_id: ID!) {
    sendNewUserMail(user_id: $user_id)
  }
`;

export const deleteDocument = gql`
  mutation DeleteDocument($id: ID!) {
    deleteDocument(id: $id)
  }
`;

export const updateDatevSettings = gql`
  mutation UpdateDatevSettings(
    $sandbox: Boolean
    $mandant_id: String
    $client_id: String
    $client_sandbox_id: String
    $target_system: String
    $document_types: String
    $payroll_base_url: String
    $payroll_sandbox_base_url: String
    $exchange_base_url: String
    $exchange_sandbox_base_url: String
    $salary_type_id_amount: Int
    $salary_type_id_ueberstunden: Int
    $salary_type_id_notdienst: Int
    $salary_type_id_spesen: Int
    $salary_type_id_nachtarbeit: Int
    $salary_type_id_sonntagsarbeit: Int
  ) {
    updateDatevSettings(
      sandbox: $sandbox
      mandant_id: $mandant_id
      client_id: $client_id
      client_sandbox_id: $client_sandbox_id
      target_system: $target_system
      document_types: $document_types
      payroll_base_url: $payroll_base_url
      payroll_sandbox_base_url: $payroll_sandbox_base_url
      exchange_base_url: $exchange_base_url
      exchange_sandbox_base_url: $exchange_sandbox_base_url
      salary_type_id_amount: $salary_type_id_amount
      salary_type_id_ueberstunden: $salary_type_id_ueberstunden
      salary_type_id_notdienst: $salary_type_id_notdienst
      salary_type_id_spesen: $salary_type_id_spesen
      salary_type_id_nachtarbeit: $salary_type_id_nachtarbeit
      salary_type_id_sonntagsarbeit: $salary_type_id_sonntagsarbeit
    ) {
      id
      sandbox
      mandant_id
      client_id
      client_sandbox_id
      target_system
      document_types
      salary_type_id_amount
      salary_type_id_ueberstunden
      salary_type_id_notdienst
      salary_type_id_spesen
      salary_type_id_nachtarbeit
      salary_type_id_sonntagsarbeit
      updated_at
    }
  }
`;

export const setEmergencyServiceRate = gql`
  mutation SetEmergencyServiceRate(
    $effective_date: Date!
    $weekday_factor: Float!
    $special_day_factor: Float!
  ) {
    setEmergencyServiceRate(
      effective_date: $effective_date
      weekday_factor: $weekday_factor
      special_day_factor: $special_day_factor
    )
  }
`;
 
export const deletePendingEmergencyServiceRate = gql`
  mutation DeletePendingEmergencyServiceRate {
    deletePendingEmergencyServiceRate
  }
`;

export const startDatevEmployeeValidation = gql`
  mutation StartDatevEmployeeValidation($month: Int!, $year: Int!) {
    startDatevEmployeeValidation(month: $month, year: $year) {
      status
      error
      started_at
    }
  }
`;
